import moment, { Moment } from 'moment';
import { ICourse, IDate } from '../types';
import { getEarliestCourseStartDate } from '../utilities/getEarliestCourseStartDate';
import { normalizeToFullYear } from './formatting';

export const isPassportExpired = (passportExpiry: string): boolean => {
  const expiryDate = moment(passportExpiry, 'YYYY-MM-DD', true);
  return moment().isSameOrAfter(expiryDate);
};

export const isPassportExpiringSoon = (courses: Array<ICourse>, passportExpiry: string): boolean => {
  const expiryDate = moment(passportExpiry, 'YYYY-MM-DD', true);
  const startDate = getEarliestCourseStartDate(courses);
  if (startDate) {
    return startDate.add(6, 'M').isAfter(expiryDate);
  } else {
    return false;
  }
};

export const isBeforeMaturityDate = (userDate?: string, maturityDate?: Moment): boolean => {
  if (userDate) {
    if (maturityDate) {
      const date = moment(userDate, 'YYYY-MM-DD', true);
      return date.startOf('day').isSameOrBefore(maturityDate);
    }
    return isOverXDaysAgo(userDate, 28);
  }
  return false;
};

export const isOverXDaysAgo = (userDate?: string, days?: number) => {
  if (userDate) {
    const date = moment(userDate, 'YYYY-MM-DD', true);
    return date.startOf('day').isSameOrBefore(moment().startOf('day').subtract(days, 'days'));
  }
  return false;
};

export const isOverXMonthsAgo = (userDate: string, months: number) => {
  const date = moment(userDate, 'YYYY-MM-DD', true);
  return date.isSameOrBefore(moment().subtract(months, 'months'));
};

export const getMaturityDate = (userDate?: string) => {
  if (userDate) {
    const date = moment(userDate, 'YYYY-MM-DD', true);
    return date.startOf('day').add(28, 'days'); //.format('DD/MM/YYYY');
  } else {
    return moment().startOf('day').add(28, 'days');
  }
};

const currentYear = new Date().getFullYear();
const MIN_YEAR = currentYear - 130;
const MAX_YEAR = currentYear + 50;

export const getMomentDate = (dateInput: IDate): Moment => {
  const { YYYY, DD, MM } = dateInput;
  const year = normalizeToFullYear(YYYY);
  return moment([year, Number(MM) - 1, Number(DD)]);
};

export const getMomentDateOrNull = (dateInput: IDate): Moment | null => {
  const { YYYY, DD, MM } = dateInput;
  if (YYYY && DD && MM) {
    return getMomentDate(dateInput);
  }
  return null;
};

export const isValidDate = (dateInput: IDate): boolean => {
  const momentDate = getMomentDateOrNull(dateInput);
  if (momentDate) {
    const year = momentDate.year();
    if (year && (year < MIN_YEAR || year > MAX_YEAR)) {
      return false;
    }
    return momentDate.isValid();
  }
  return false;
};

export const isFutureDate = (dateInput: IDate): boolean => {
  const futureDate = getMomentDateOrNull(dateInput);
  if (futureDate) return futureDate.isSameOrAfter(moment());
  return false;
};

export const isPastDate = (dateInput: IDate): boolean => {
  const pastDate = getMomentDateOrNull(dateInput);
  if (pastDate) return pastDate.isSameOrBefore(moment());
  return false;
};

export const isValidDateAndPast10YearsOrInFuture = (dateInput: IDate): boolean => {
  const pastDate = getMomentDateOrNull(dateInput);
  if (pastDate) {
    return pastDate.isSameOrAfter(moment().subtract(11, 'y'));
  }
  return false;
};
